module.exports = __webpack_public_path__ + "img/quickRoute3.66ae1a95.png";